import { render, staticRenderFns } from "./VesselComparisonEmptyState.vue?vue&type=template&id=5d162efb&scoped=true&"
import script from "./VesselComparisonEmptyState.vue?vue&type=script&lang=ts&"
export * from "./VesselComparisonEmptyState.vue?vue&type=script&lang=ts&"
import style0 from "./VesselComparisonEmptyState.vue?vue&type=style&index=0&id=5d162efb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d162efb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
